module.exports = __webpack_public_path__ + "img/top_bg.649f95b2.png";